var exports = {
  "TT": "ProfileCardUserInfo.module__userInfoContainer___b1lzUH",
  "S7": "ProfileCardUserInfo.module__nameRow___b1lzUH",
  "oo": "ProfileCardUserInfo.module__nameButton___b1lzUH",
  "uV": "ProfileCardUserInfo.module__nameButtonClickable___b1lzUH",
  "fC": "ProfileCardUserInfo.module__badgeContainer___b1lzUH",
  "NW": "ProfileCardUserInfo.module__userTagWrapper___b1lzUH",
  "Hq": "ProfileCardUserInfo.module__actionsContainer___b1lzUH",
  "Fj": "ProfileCardUserInfo.module__usernameRow___b1lzUH",
  "xO": "ProfileCardUserInfo.module__usernameButton___b1lzUH",
  "hI": "ProfileCardUserInfo.module__pronouns___b1lzUH",
  "sM": "ProfileCardUserInfo.module__srOnly___b1lzUH",
};

module.exports = exports;
